/**
 * Which `media:*` reports to send for our mic and camera.
 *
 * The server keeps them in Presence (`video_on`, `audio_muted`), which every
 * roster shows and a late joiner is replayed. `last` is what this channel has
 * already been told — null right after a join, so both are stated then.
 *
 * Camera before mic: `audio_muted` is the marker that says we report (see
 * PeerPresence.media), so the camera is already right when a roster starts
 * trusting it.
 */
export type MediaReport = 'media:camera_on' | 'media:camera_off' | 'media:mic_on' | 'media:mic_off'

export function mediaReports(
  last: { mic: boolean; cam: boolean } | null,
  now: { mic: boolean; cam: boolean },
): MediaReport[] {
  const out: MediaReport[] = []
  if (!last || last.cam !== now.cam) out.push(now.cam ? 'media:camera_on' : 'media:camera_off')
  if (!last || last.mic !== now.mic) out.push(now.mic ? 'media:mic_on' : 'media:mic_off')
  return out
}
